import React from 'react'
import classNames from 'classnames';
import move from '../../assets/images/icon/move.png';
import trashcan from '../../assets/images/icon/trashcan.png';
import arrow_up from '../../assets/images/icon/arrow_up.png';
import arrow_down from '../../assets/images/icon/arrow_down.png';
import icon_copy from '../../assets/images/icon/copy.png';
import icon_switch from '../../assets/images/icon/switch.png';
import icon_qustion from '../../assets/images/icon/icon_qustion_mark.png';

interface ContentControlProps {
  className?: string;
  children: React.ReactNode;
  onClick?: (e) => void;
  style?;
  dragHandleProps?;
  handleConfig?: (keyof typeof CONTENT_HANDLES | {
    handleName: keyof typeof CONTENT_HANDLES;
    show?: boolean;
    onClick?: (e) => void;
  })[];
}

export default React.forwardRef<HTMLDivElement, ContentControlProps>(({ className, children, onClick, handleConfig = [], dragHandleProps, ...props }, ref) => {

  const onMouseOver = (e: any) => {
		// if (canDrop) {
		// 	return;
		// }
		const { currentTarget } = e;
		currentTarget.classList.add('hover');
	}
  const onMouseOut = (e: any) => {
		const { currentTarget } = e;
		currentTarget.classList.remove('hover');
	}

  const handles = handleConfig.map((config) => typeof config === 'string' ? CONTENT_HANDLES[config] : ({ ...config, ...CONTENT_HANDLES[config.handleName] }))
  
  return (
    <div
      className={classNames('content-wrapper', className)}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={onClick}
      ref={ref}
      {...props}
    >
      {children}
      <div className="content-handler">
        {handles.map(({ show, image, alt, ...props }) => show !== false && <button {...props}><img src={image} alt={alt} /></button>)}
      </div>
    </div>)
});

const CONTENT_HANDLES = {
  move: {
    className: 'move',
    image: move, 
    alt: 'drag handle',
  },
  prev: {
    className: 'prev',
    image: arrow_up,
    alt: 'move up',
  },
  next: {
    className: 'next',
    image: arrow_down,
    alt: 'move down',
  },
  copy: {
    className: 'copy',
    image: icon_copy,
    alt: 'copy',
  },
  remove: {
    show: true,
    className: 'remove',
    image: trashcan,
    alt: 'remove',
  },
  switch: {
    className: 'content-switch',
    image: icon_switch,
    alt: 'switch',
  },
  upgrade: {
    className: 'upgrade',
    image: icon_qustion,
    alt: 'upgrade',
  },
};